import React, { useState, useEffect } from 'react';
import './Improvements.css';
import axios from 'axios';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useUser } from '../../providers/UserContext';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal } from 'antd'; // Importar el modal de antd
import { Link } from 'react-router-dom'; // Para el enlace al componente de planes
import LoadingScreen from '../LoadingScreen/LoadingScreen';
import PremiumRequiredCard from '../PremiumRequiredCard/PremiumRequiredCard';
import NoReviewsCard from '../NoReviewsCard/NoReviewsCard';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const Improvements = () => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [errorLoading, setErrorLoading] = useState(null);
  const [activeTab, setActiveTab] = useState('availableReports');
  const [requestedReports, setRequestedReports] = useState([]);
  const [usuario, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isExpired, setIsExpired] = useState(true);
  const [showLimitModal, setShowLimitModal] = useState(false); // Estado para mostrar el modal

  const { user } = useUser();
  const [businessData, setBusinessData] = useState(user?.business_data || null);
  const apiKey = process.env.REACT_APP_X_API_KEY;
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiReports = process.env.REACT_APP_API_REPORTS;

  const isMobile = window.innerWidth <= 768;

  const navigate = useNavigate(); // Hook para navegar

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const maxReports = 2 // número limite de reportes para usuarios basic

  const fetchData = async () => {
    try {
      // var userUID = user.uid ? user.uid : localStorage.getItem("userUID")
      // const response = await axios.get(`${apiUrl}/collections/user/${userUID}`);
      // setUser(response.data);
      // const checkSubscriptionStatus = (usuario) => {
      //   const parseDate = (dateString) => {
      //     const [day, month, year] = dateString.split('/').map(Number);
      //     return new Date(year, month - 1, day); // Los meses en JavaScript son indexados desde 0
      //   };
      //   if (usuario) {
      //     if (!usuario.is_premium) {
      //       const registrationDate = parseDate(usuario.date);
      //       const expirationDate = new Date(registrationDate);
      //       expirationDate.setDate(expirationDate.getDate() + 7);
      //       const currentDate = new Date();
      //       setIsExpired(currentDate > expirationDate);
      //     }
      //   }
      // };
    
      // checkSubscriptionStatus(user);
      setBusinessData(user?.business_data || null)
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setErrorLoading(true);
    }
  };

  // const fetchBusinessData = async () => {
  //   if (user && user.businessId) {
  //     try {
  //       const collection = 'todo_restaurantes_españa';
  //       const response = await axios.get(`${apiUrl}/collections/${collection}/${user.businessId}`);
  //       setBusinessData(response.data);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //       setErrorLoading(true);
  //     }
  //   }
  // };

  useEffect(() => {
    fetchData();
    //fetchBusinessData();
  }, [user, businessData]);

  useEffect(() => {
    if (errorLoading) {
      navigate('/404'); // Redirige a la página 404 si hay un error
    }
  }, [errorLoading, navigate]);

  const handleReportCount = async (e) => {
    try {
      user.reports = user.reports + 1;
      await axios.post(`${apiUrl}/collections/update-user-reports`, {
        email: user.email,
        id_negocio: user.id_negocio,
        reports: user.reports ? user.reports : 1
      });
    } catch (error) {
      console.error('Error al actualizar el número de informes realizados:', error);
    }
    fetchData();
  };

  const reportOptions = [
    {
      id: '5',
      title: t('reportsList.bestAndWorst.title'),
      description: t('reportsList.bestAndWorst.description'),
      imgSrc: '../../../assets/images/Reports/Reports_5.jpg',
      plan: "basic"
    },
    {
      id: '4',
      title: t('reportsList.lastYear.title'),
      description: t('reportsList.lastYear.description'),
      imgSrc: '../../../assets/images/Reports/Reports_4.jpg',
      plan: "basic"
    },
    {
      id: '6',
      title: t('reportsList.quickTips.title'),
      description: t('reportsList.quickTips.description'),
      imgSrc: '../../../assets/images/Reports/Reports_6.jpg',
      plan: "premium"
    },
    {
      id: '1',
      title: t('reportsList.customerFeedback.title'),
      description: t('reportsList.customerFeedback.description'),
      imgSrc: '../../../assets/images/Reports/Reports_1.jpg',
      plan: "premium"
    },
    {
      id: '2',
      title: t('reportsList.keyTips.title'),
      description: t('reportsList.keyTips.description'),
      imgSrc: '../../../assets/images/Reports/Reports_2.jpg',
      plan: "premium"
    },
    {
      id: '3',
      title: t('reportsList.negativeFeedback.title'),
      description: t('reportsList.negativeFeedback.description'),
      imgSrc: '../../../assets/images/Reports/Reports_3.jpg',
      plan: "premium"
    }
  ];



  const showToast = () => {
    toast.info(t('improvementsToast'), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const handleRequestReport = async (reportId) => {
    if (!user.is_premium && user.reports >= maxReports) {
      // Si el usuario ha alcanzado el límite de 2 informes
      setShowLimitModal(true);
      return;
    }

    setIsLoading(true);
    setResponse(null);
    setError(null);

    try {
      if (user && user.id_negocio) {
        showToast();
        const id_negocio = user.id_negocio;
        const fecha_informe = new Date().toISOString();

        const mongoResponse = await axios.post(`${apiUrl}/collections/save-report`, {
          id_negocio,
          id_informe: reportId,
          fecha_informe,
          texto: 'Informe en proceso...',
          status: 'Processing',
          language: i18n.language
        });

        handleReportCount();

        const informeIdMongo = mongoResponse.data._id;

        const lambdaResponse = await fetch(apiReports, {
          method: "POST",
          body: JSON.stringify({
            id_negocio: id_negocio,
            informe_id: informeIdMongo,
            id_informe: reportId,
            language: i18n.language
          }),
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
        });

        if (lambdaResponse.status === 200) {
          setResponse('El informe está siendo procesado.');

          const newReport = {
            title: reportOptions.find(r => r.id === reportId).title,
            fechaSolicitud: fecha_informe,
            status: 'En proceso',
            fechaEntrega: null,
            downloadLink: null,
          };

          setRequestedReports(prevReports => [...prevReports, newReport]);

        } else {
          throw new Error('Error al iniciar el procesamiento del informe en Amazon');
        }
      }
    } catch (error) {
      setError('Error al generar el informe: ' + error.message);
      console.error('Error al generar el informe:', error);
    } finally {
      setIsLoading(false);
    }
  };

  function parseHtmlToPdfMakeContent(html) {
    console.log("HTML: ", html);
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const content = [];

    function processNode(node) {
      if (!node) return;

      switch (node.nodeType) {
        case Node.ELEMENT_NODE:
          const style = node.getAttribute('style') || '';
          switch (node.tagName) {
            case 'H1':
              content.push({ text: node.textContent, style: 'header' });
              break;
            case 'H2':
              content.push({ text: node.textContent, style: 'subheader' });
              break;
            case 'H3':
              content.push({ text: node.textContent, style: 'sectionTitle' });
              break;
            case 'P':
              if (style.includes('background-color: #e6f3ff')) {
                content.push({ text: node.textContent, style: 'positiveReview' });
              } else if (style.includes('background-color: #ffe6e6')) {
                content.push({ text: node.textContent, style: 'negativeReview' });
              } else if (style.includes('background-color: #f0f0f0')) {
                content.push({ text: node.textContent, style: 'locationInfo' });
              } else {
                content.push({ text: node.textContent, style: 'paragraph' });
              }
              break;
            case 'DIV':
              if (style.includes('background-color: #f0f0f0')) {
                content.push({ text: node.textContent, style: 'locationInfo' });
              } else {
                node.childNodes.forEach(processNode);
              }
              break;
            case 'UL':
              const listItems = [];
              node.childNodes.forEach(child => {
                if (child.tagName === 'LI') {
                  listItems.push({ text: child.textContent });
                }
              });
              content.push({ ul: listItems, style: 'list' });
              break;
            case 'OL':
              const orderedListItems = [];
              node.childNodes.forEach(child => {
                if (child.tagName === 'LI') {
                  orderedListItems.push({ text: child.textContent });
                }
              });
              content.push({ ol: orderedListItems, style: 'list' });
              break;
            case 'IMG':
              content.push({ image: node.src, width: 100 });
              break;
            default:
              node.childNodes.forEach(processNode);
          }
          break;
        case Node.TEXT_NODE:
          if (node.textContent.trim()) {
            content.push({ text: node.textContent });
          }
          break;
      }
    }

    doc.body.childNodes.forEach(processNode);

    return content;
  }


  const handleDownloadReport = async (report) => {
    const reportTitle = reportOptions.find(r => r.id === report.id_informe)?.title || 'Informe de Reseñas';
    const sanitizedHtml = report.informe_html.replace(/```html|```/g, '');
    const pdfContent = parseHtmlToPdfMakeContent(sanitizedHtml);

    const reveatLightYellow = getComputedStyle(document.documentElement).getPropertyValue('--reveat-lightyellow').trim();
    const reveatYellow = getComputedStyle(document.documentElement).getPropertyValue('--reveat-yellow').trim();
    const reveatBlack = getComputedStyle(document.documentElement).getPropertyValue('--reveat-black').trim();

    // Definición de SVG para header y footer con el nuevo color
    const headerSvg = `
      <svg width="600" height="100" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="headerGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style="stop-color:${reveatLightYellow};stop-opacity:1" />
            <stop offset="100%" style="stop-color:${reveatYellow};stop-opacity:1" />
          </linearGradient>
        </defs>
        <path d="M0,0 C150,20 350,0 600,100 L600,0 Z" fill="url(#headerGradient)" />
      </svg>
    `;

    const footerSvg = `
    <svg width="600" height="200" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="footerGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style="stop-color:${reveatYellow};stop-opacity:1" />
          <stop offset="100%" style="stop-color:${reveatLightYellow};stop-opacity:1" />
        </linearGradient>
      </defs>
      <path d="M0,200 C250,150 450,200 600,0 L600,200 Z" fill="url(#footerGradient)" />
    </svg>
  `;


    const docDefinition = {
      content: [
        {
          svg: headerSvg,
          width: 600,
          height: 100,
          margin: [0, 0, 0, -40]
        },
        {
          columns: [
            {
              width: '*', // Espacio vacío
              text: ''
            },
            {
              width: 'auto',
              image: 'logo',
              width: 60,
              margin: [0, -50, 10, 0], // margen derecho de 10
              alignment: 'right'
            }
          ]
        },
        {
          stack: [
            ...pdfContent
          ],
          margin: [60, 0, 60, 0]
        },
        {
          svg: footerSvg,
          width: 600,
          height: 200, // Altura del footer incrementada
          margin: [0, 0, 0, 0]
        },
        {
          columns: [
            {
              width: '*', // Espacio vacío
              text: ''
            },
            {
              width: 'auto',
              stack: [
                {
                  image: 'logoFooter',
                  width: 60,
                  margin: [0, -60, -3, 0], // margen derecho de 10
                  alignment: 'right'
                },
                {
                  text: 'RevEat', style: 'footerText', alignment: 'right'
                },
                {
                  text: '+34 605 48 96 73', style: 'footerSubText', alignment: 'right'
                },
                {
                  text: 'reveatpro@gmail.com', style: 'footerSubText', alignment: 'right'
                }
              ],
              margin: [0, -60, 20, 0] // margen derecho ajustado a 10
            }
          ]
        }
      ],

      styles: {
        header: {
          fontSize: 24,
          bold: true,
          margin: [0, 20, 0, 10],
          color: reveatBlack,
          decoration: 'underline'
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 20, 0, 10],
          color: reveatBlack,
          decoration: 'underline'
        },
        paragraph: {
          fontSize: 12,
          margin: [5, 0, 5, 10]
        },
        positiveReview: {
          fontSize: 12,
          italics: true,
          margin: [10, 5, 10, 5],
          color: "#555",
          background: '#e6f3ff',
          padding: [5, 5, 5, 5]
        },
        negativeReview: {
          fontSize: 12,
          italics: true,
          margin: [10, 5, 10, 5],
          color: "#555",
          background: '#ffe6e6',
          padding: [5, 5, 5, 5]
        },
        sectionTitle: {
          fontSize: 16,
          bold: true,
          color: reveatBlack,
          margin: [0, 10, 0, 5],
          decoration: 'underline'
        },
        locationInfo: {
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 0],
          background: '#ffffff',
          padding: [15, 5, 15, 5]
        },
        headerText: {
          fontSize: 24,
          bold: true,
          color: "#ffffff",
          margin: [0, 5, 0, 5]
        },
        headerSubText: {
          fontSize: 14,
          color: "#ffffff",
          margin: [0, 2, 0, 2]
        },
        footerText: {
          fontSize: 16,
          bold: true,
          color: reveatBlack,
          margin: [0, 5, 0, 5]
        },
        footerSubText: {
          fontSize: 12,
          color: reveatBlack,
          margin: [0, 2, 0, 2]
        },
        list: {
          fontSize: 12,
          margin: [0, 0, 0, 10]
        }
      },
      images: {
        logo: `${window.location.origin}/assets/images/RevEat_Logo_PNG_Blanco.png`,
        logoFooter: `${window.location.origin}/assets/images/RevEat_Logo_PNG_Blanco.png`
      },
      pageSize: 'A4',
      pageMargins: [0, 0, 0, 20]
    };

    pdfMake.createPdf(docDefinition).download(`RevEat_${reportTitle}.pdf`);
  };

  const fetchRequestedReports = async () => {
    if (user && user.id_negocio) {
      try {
        const encodedIdNegocio = encodeURIComponent(user.id_negocio);
        const response = await axios.get(`${apiUrl}/collections/get-reports/${encodedIdNegocio}`);
        if (response.status === 200) {
          setRequestedReports(response.data);
        } else {
          setError('Error al obtener los informes solicitados');
        }
      } catch (error) {
        console.error('Error al obtener los informes solicitados:', error);
        setError('Error al obtener los informes solicitados');
      }
    }
  };

  // Realiza la consulta periódica para actualizar la tabla
  useEffect(() => {
    fetchRequestedReports();

    const intervalId = setInterval(() => {
      fetchRequestedReports(); // Actualiza la lista de informes solicitados
    }, 10000); // 10000ms = 10 segundos

    return () => clearInterval(intervalId); // Limpia el intervalo cuando se desmonta el componente
  }, [user, activeTab]);

  if(loading || !businessData){
    return <LoadingScreen setLoadingComplete={setLoading} />;
  }

  if (user && !user.is_expired && (!businessData || !businessData.allReviews || (Array.isArray(businessData.allReviews) && businessData.allReviews.length===0))) {
    return <NoReviewsCard />;
  }

  if(user && !user.is_premium && user.is_expired){
    return <PremiumRequiredCard/>
  }

  return (
    <div className="improvements content pt-0">
      <div className='footer-margin'>
      <ToastContainer />
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'availableReports' ? 'active font-weight-bold' : ''}`}
            onClick={() => setActiveTab('availableReports')}
            style={{ fontSize: isMobile ? '12px' : '14px' }}
          >
            {t('reportsAvailable')}
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'requestedReports' ? 'active font-weight-bold' : ''}`}
            onClick={() => setActiveTab('requestedReports')}
            style={{ fontSize: isMobile ? '12px' : '14px' }}
          >
            {t('reportsRequested')}
          </button>
        </li>
      </ul>

      <div className="tab-content">
        {activeTab === 'availableReports' && (
          <div className="availableReports-wrapper">
            <div className="row report-list">
              {reportOptions.map(report => (
                <div className="card mx-2 mb-4" key={report.id}>
                  <div className="card-body">
                    <div className="card-img-actions mb-3">
                      <img className="card-img" src={report.imgSrc} alt={report.title} />
                    </div>
                    <h5 className="card-title pt-1 mb-2">
                      {report.title}
                    </h5>
                    <div className="card-description">
                      <p className="card-text">{report.description}</p>
                    </div>
                  </div>
                  <div className="card-footer">
                    <button
                      onClick={() => {
                        // Verificamos si el usuario existe
                        if (user) {
                          // Si el usuario es premium, puede acceder a cualquier informe
                          if (user.is_premium) {
                            handleRequestReport(report.id); // Solicitar el informe
                          }
                          // Si el usuario es basic y el informe es basic
                          else if (report.plan === "basic") {
                            handleRequestReport(report.id); // Solicitar el informe
                          }
                          // Si el usuario es basic y el informe es premium
                          else {
                            navigate('/plans'); // Navegar a la página de planes
                          }
                        } else {
                          // Manejo opcional si el usuario es null
                          navigate('/login'); // O redirigir a la página de inicio de sesión
                        }
                      }}
                      className={user && user.is_premium ? "btn-basic" : report.plan == "basic" ? "btn-basic" : "btn-premium"}
                    >
                      {user && user.is_premium
                        ? t('reportButton') // Botón para usuarios premium
                        : report.plan === "basic"
                          ? t('reportButton') // Botón para usuarios basic si el informe es basic
                          : t('reportButtonPremium') // Texto para usuarios basic si el informe es premium
                      }
                      <i className="ph-arrow-circle-right ms-2"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

        )}

        {activeTab === 'requestedReports' && (
          <div className="table-container">
            <div className="table-responsive">
              <table className="table">
                <thead className="table-header">
                  <tr>
                    <th>{t('reportName')}</th>
                    <th>{t('reportDateRequest')}</th>
                    <th>{t('reportDateDelivery')}</th>
                    <th>{t('status')}</th>
                    <th>{t('download')}</th>
                  </tr>
                </thead>
                <tbody className="table-body">
                  {requestedReports.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center">{t('reportTableEmpty')}</td>
                    </tr>
                  ) : (
                    requestedReports
                      // Filtra los informes que no tengan un downloadLink o que estén "En proceso"
                      .filter(report => report.downloadLink !== null || report.status !== 'En proceso')
                      .map((report, index) => {
                        const reportOption = reportOptions.find(r => r.id === report.id_informe);
                        //console.log('Requested Report:', report);
                        //console.log('Matched Report Option:', reportOption);

                        return (
                          <tr key={index}>
                            <td>{reportOption?.title || "Informe Desconocido"}</td>
                            <td>{new Date(report.fecha_informe).toLocaleString()}</td>
                            <td>{report.status === "Ready" ? new Date(report.report_date).toLocaleString() : "En proceso"}</td>
                            <td className={report.status === 'Ready' ? 'text-success' : 'text-warning' }>
                              {report.status === 'Ready' ? t('ready') : t('processing')}
                              <i className={report.status === 'Ready' ? 'ph-check' : 'ph-timer'}></i>
                            </td>
                            <td>
                              {report.status === "Ready" ? (
                                <i
                                  className="ph-download-simple btn btn-link me-2 downloadbutton"
                                  onClick={() => handleDownloadReport(report)}
                                ></i>
                              ) : (
                                <i
                                  className="ph-download-simple btn btn-link me-2 downloadbutton"
                                  style={{ cursor: 'not-allowed'}}
                                  disabled
                                ></i>
                              )}
                            </td>
                          </tr>
                        );
                      })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      {/* Modal que se muestra cuando el usuario alcanza el límite */}
      <Modal
        title={t('limitReached')}
        visible={showLimitModal}
        onCancel={() => setShowLimitModal(false)}
        footer={[
          <Link key="plans" to="/plans" className='btn-upgrade btnPremium'>
            {t('plans')}
            <i className="ph-arrow-circle-right ms-2"></i>
          </Link>
        ]}
      >
        <p>{t('limitMessage')}</p>
      </Modal>
      </div>
    </div>
  );
};

export default Improvements;